
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { BLogoH, IconSearch } from '@/components/svg'

interface Language {
  iso: string;
  name: string;
}

@Component({
  components: { BLogoH, IconSearch }
})
export default class Header extends Vue {
  showMenu = false;
  showCountries = false;
  showTags = false;
  url: string = window.location.origin;
  lang: Language[] = [
    { iso: 'en', name: 'EN' },
    { iso: 'zh', name: '中' }
  ];

  setLang(lang: string) {
    if (lang !== this.$i18n.locale) {
      window.localStorage.setItem('lang', lang)
      window.location.href = `${this.url}`
    //   window.location.href = `${this.url}?lang=${lang}&no-loading=true`
    }
  }
}
